export default function CoffeeButton() {
  return (
    <a
      className="bg-sky-50 rounded-md shadow inline-flex items-center px-3 py-2 text-sky-600 hover:bg-sky-100 hover:text-sky-700"
      target="_blank"
      rel="noreferrer"
      href="https://www.buymeacoffee.com/amanjaiman"
    >
      <img
        className="h-5"
        src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
        alt="Buy me a coffee"
      />
      <span className="hidden md:block ml-3 font-medium">Buy me a coffee</span>
    </a>
  )
}